<template>
    <div class="travel-notes-detail">
        <travel-notes-info></travel-notes-info>

        <div class="container">
            <!-- 航线推荐 -->
            <promo-cruise></promo-cruise>
            <!-- 来稿 -->
            <email-share-in-detail></email-share-in-detail>
        </div>
    </div>
</template>

<script>
    import TravelNotesInfo from '@/components/Review/TravelNotesInfo'
    import PromoCruise from '@/components/Cruise/PromoCruise'
    import EmailShareInDetail from '@/components/Review/EmailShareInDetail'

    export default {
        name: 'TravelNotesDetail',
        components: {
            TravelNotesInfo,
            PromoCruise,
            EmailShareInDetail,
        },
        data () {
            return {}
        },
        beforeMount () {},
        methods: {},
    }
</script>

<style lang="less" scoped>
    .travel-notes-detail {
        position: relative;
        padding-bottom: 74px;
        background-color: #f5f5f5;
    }
</style>
